<template>
  <validation-observer ref="applicationForm" v-if="Object.keys(formData).length">
    <guidance
      v-if="calculatorType"
      :applicationType="calculatorType"
      :communityId="communityId"
      class="mb-4"
    />
    <div v-for="tab in json.tabs" :key="tab.tag" :title="tab.title" class="calculator-form">
      <template v-for="formField in tab.formFields">
        <h2 class="form-legend-title" :key="formField.id">{{formField.title}}</h2>
        <form-group
          v-for="formGroup in formField.formGroups"
          :key="formGroup.for"
          :data="formGroup"
          :tab="tab.tag"
        >
        </form-group>
      </template>
    </div>
    <p>
      <b-button @click="calculate" variant="danger" v-if="calculatorType !== 'PR' && calculatorType !== 'GE'" class="btn">Berechnen</b-button>
    </p>
    <div v-if="calculatorType === 'GE'">{{calculate()}}</div>

    <b-alert v-model="hasUnknownError" variant="danger" class="mt-3">
      {{ unknownErrorMessage }}
    </b-alert>
  </validation-observer>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import Guidance from '@/components/application/Intro/Guidance.vue'
  import FormGroup from '@/components/calculator/FormComponents/FormGroup.vue'

  export default {
    data: () => ({
      isValid: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      formErrors: {},
      json: {}
    }),
    created () {
      this.getCalculatorForm()
    },
    methods: {
      getCalculatorForm () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('calculator/GET_CALCULATOR_FORM').then(res => {
          const { data, errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          this.json = data.calculatorFormByCode
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      calculate () {
        this.$store.dispatch('calculator/GET_ESTIMATE').then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      ...mapState({
        communityId: state => state.calculator.communityId,
        calculatorType: state => state.calculator.calculatorType,
        formData: state => state.calculator.formData
      })
    },
    watch: {
      calculatorType (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getCalculatorForm()
        }
      }
    },
    components: {
      FormGroup,
      ValidationObserver,
      Guidance
    }
  }
</script>
<style lang="scss" scoped>
  .calculator-form::v-deep{
    .form-legend-title {
      color: $magenta;
    }
    label{
      padding-top: 0;
      padding-bottom: .2rem;
      margin-bottom: 0;
    }
    span{
      display: block;
      width: 100%;
    }
  }
</style>
